import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export function getSelectedImage(state: ApplicationState, product: ProductModel | undefined) {
    const { selectedImageIndex } = state.pages.productDetails;
    if (!product || !product.images || product.images.length <= selectedImageIndex) {
        return;
    }

    return product.images[selectedImageIndex];
}
